// Shared by the API and browser. Compare calendar dates in PATH's business timezone.
const FUTURE_INTERVENTION_START_ERROR = 'future_intervention_start';
const businessDayFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit',
});
const displayDateFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'UTC', year: 'numeric', month: 'long', day: 'numeric',
});

function getFutureInterventionDeliveryError({ startDate, deliveryStatus, now = new Date() }) {
  if (!['in_progress', 'suspended'].includes(deliveryStatus)) return null;
  // Invalid/missing dates remain the responsibility of the existing date validation.
  const date = String(startDate || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
  const parsed = new Date(`${date}T00:00:00.000Z`);
  if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return null;
  const parts = Object.fromEntries(businessDayFormatter.formatToParts(now).map(part => [part.type, part.value]));
  const today = `${parts.year}-${parts.month}-${parts.day}`;
  if (date <= today) return null;
  return {
    error: FUTURE_INTERVENTION_START_ERROR,
    startDate: date,
    message: `This intervention starts on ${displayDateFormatter.format(parsed)}. Future-dated interventions cannot be activated or suspended. Keep it Approved until it starts. If the start date is incorrect, correct it before trying again.`,
  };
}

module.exports = { FUTURE_INTERVENTION_START_ERROR, getFutureInterventionDeliveryError };
